document.addEventListener("DOMContentLoaded", () => {
  // 埋め込みたい投稿のパーマリンクを並べる（各URLは末尾の / を付ける）
  const instaUrls = [
    "https://www.instagram.com/p/DQ-5sCIjwOk/?utm_source=ig_web_copy_link&igsh=MzRlODBiNWFlZA==/",
    "https://www.instagram.com/p/DN708hPXgVn/?utm_source=ig_web_copy_link&igsh=MzRlODBiNWFlZA==/",
    "https://www.instagram.com/p/DN2rWn33tSb/?utm_source=ig_web_copy_link&igsh=MzRlODBiNWFlZA==/",
    "https://www.instagram.com/p/DNzSTRo3i2X/?utm_source=ig_web_copy_link&igsh=MzRlODBiNWFlZA==/",
  ];

  const cards = document.querySelectorAll(".whip_sns_card");

  cards.forEach((el, i) => {
    const url = instaUrls[i];
    if (!url) return; // URLが足りないカードはスキップ
    el.innerHTML = `
      <blockquote class="instagram-media"
        data-instgrm-permalink="${url}"
        data-instgrm-version="14"
        style="margin:0 auto; max-width:540px; width:100%;"
      ></blockquote>
    `;
  });

  // 生成したblockquoteをInstagram側でiframe化
  if (window.instgrm?.Embeds?.process) {
    window.instgrm.Embeds.process();
  } else {
    // 念のため: embed.jsの読み込みが終わってから実行
    window.addEventListener("load", () => window.instgrm?.Embeds?.process());
  }
});
